module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN201_2086322261.4893283f.png";